import { authorization } from '@united-talent-agency/julius-frontend-store';

export const hasAccess = (feature, option, application = 'projects') => {
  return authorization.hasAccess(application, feature, option);
};
export default { hasAccess };
